import { useState, useEffect } from 'react';
import { detectPlatform, type DetectedPlatform } from '../utils/platformDetection';

/**
 * React hook that detects the user's platform (OS + architecture) on mount
 * @returns DetectedPlatform object or null if detection hasn't completed yet
 */
export function usePlatformDetection(): DetectedPlatform | null {
  const [detectedPlatform, setDetectedPlatform] = useState<DetectedPlatform | null>(null);

  useEffect(() => {
    // Run detection on mount
    try {
      const platform = detectPlatform();
      setDetectedPlatform(platform);
    } catch (error) {
      console.error('Failed to detect platform:', error);
      // Set unknown platform on error
      setDetectedPlatform({ os: 'unknown', architecture: 'unknown' });
    }
  }, []); // Empty dependency array = run once on mount

  return detectedPlatform;
}
